module.exports = __webpack_public_path__ + "img/map-am.059b2e56.jpg";